import React from 'react';
import {Button, Form, Input} from "reactstrap";
import G from "../../libs/Glob.mjs";
import TextLabel from "../../controls/TextLabel.mjs";
import appLib from "../../libs/appLib.mjs";
import CheckIcon from "../../media/images/CheckIcon.mjs";
import AthenaLogo from "../../media/images/AthenaLogo.mjs";
import LanguageSwitcher from "../../controls/LanguageSwitcher.mjs";

const LoginForm = class extends React.Component {
	constructor(props) {
		super(props);
		this.state = {};
		this.uid = G.generateUid('LoginForm');
		this.checkLogin = this.checkLogin.bind(this);
	}
	componentDidMount() {
	}

	checkLogin() {
		if (! this.state.username || ! this.state.password) return false
		this.setState({loggingIn: true});
		appLib.login(
			this.state.username,
			this.state.password,
		).then(  udata=>{
			if ( ! udata ) {
				throw new Error('An error occurred while logging in.');
			}
		}).catch( () => {
			this.setState({
				password: '',
				error: G.label("Authentication error")
			});
			setTimeout( () => { this.setState({error: undefined});}, 2000);
		}).finally( ()=>{
			this.setState({loggingIn: false});
		});
	}

	render() {
		return(
			<div className={"Login LoginForm app-panel-small"} id={this.uid}>
				<h4>
					<AthenaLogo />
					<span>
						<TextLabel value={"System login"} />
					</span>
				</h4>
				<div>
					<Form
						key={this.props.lang}
						onSubmit={(e) => {
							e.preventDefault();
							e.stopPropagation();
							if (!this.state.username || !this.state.password || !!this.state.loggingIn) return;
							this.checkLogin();
						}}
					>
						<div>
							<Input
								type={"text"}
								value={this.state.username || ''}
								placeholder={G.label("Username")}
								autoFocus={!this.state.username}
								onChange={(e) => this.setState({username: e.target.value})}
							/>
							<Input
								type={"password"}
								value={this.state.password || ''}
								autoFocus={!!this.state.username}
								placeholder={G.label("Password")}
								onChange={(e) => this.setState({password: e.target.value})}
							/>
							<div>
								<div>
									{this.state.error ? (
										<p className={"error"}>
											{this.state.error}
										</p>
									) : <LanguageSwitcher />
									}
								</div>
								<Button
									className={"btn-icon"}
									type="submit"
									color="success"
									disabled={!this.state.username || !this.state.password || !!this.state.loggingIn}
									onClick={this.checkLogin}
								>
									<b>
										Login
									</b>
									<i>
										<CheckIcon/>
									</i>
								</Button>
							</div>
						</div>
					</Form>
				</div>
			</div>
		);
	}
}

export default LoginForm;